module.exports = __webpack_public_path__ + "static/media/imdb_tables.1d0b56a2.png";